module.exports = __webpack_public_path__ + "static/media/kassa24-black.c27b8976.svg";